﻿import { apiEndpoints } from "@/helpers";
import { useGetDynamicAutoCompleteQuery, useGetUserQuery } from "@/services";
import { useEffect, useState } from "react";
interface IDepartmentDocument {
  name: string;
  department: string;
  costCenter: string;
  tenantId: string;
  tenantName: string;
}

export const useDefaultDepartmentDocument = (
  userId?: string
): IDepartmentDocument | undefined => {
  const [defaultDepartmentDocument, setDefaultDepartmentDocument] =
    useState<IDepartmentDocument>();

  const { data: user } = useGetUserQuery(userId, {
    skip: !userId,
  });

  const [url, setUrl] = useState<string>();
  const { data: autoCompleteValue } = useGetDynamicAutoCompleteQuery(url, {
    skip: !url,
  });
  useEffect(() => {
    if (!user) return;
    const { department, costCenter, tenantId } = user;
    const filter = encodeURIComponent(`TenantId eq '${tenantId}'`);
    setUrl(
      `${
        apiEndpoints.departments.suggestions
      }WithFilter?query=${encodeURIComponent(
        department
      )}&filter=${filter}&CostCenter=${costCenter}`
    );
  }, [user]);

  useEffect(() => {
    if (!autoCompleteValue) return;
    const workingData = autoCompleteValue[0]?.document;

    setDefaultDepartmentDocument({
      name: workingData?.name,
      department: workingData?.name,
      costCenter: workingData?.costCenter,
      tenantId: workingData?.tenantId,
      tenantName: workingData?.tenantName,
    });
  }, [autoCompleteValue]);
  return defaultDepartmentDocument;
};
